module["exports"] = [
  "Jr.",
  "Sr.",
  "I",
  "II",
  "III",
  "IV",
  "V"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nl/name/suffix.js
 ** module id = 821
 ** module chunks = 0
 **/